// extracted by mini-css-extract-plugin
export default {"taxTable":"TaxAccruals_taxTable__W8zrA","radioLabel":"TaxAccruals_radioLabel__Urm7t"};